/** Cards and group headings of the game setup page. */
import React from 'react'
import { View, Text } from 'react-native'
import { useTheme } from '../../../hooks/useTheme'

/** Heading of a group inside a card (Table, Players, Board…); a rule above unless first. */
export function GroupHeading({ title, first }: { title: string; first?: boolean }) {
  const { theme } = useTheme()
  return <Text accessibilityRole="header"
    className={`font-stencil uppercase ${first ? '' : 'border-t border-olive/40'}`}
    style={{ fontSize: 12, letterSpacing: 1.2, color: theme === 'dark' ? '#d9d3bd' : '#3b3a2e',
      marginTop: first ? 8 : 20, paddingTop: first ? 0 : 14, marginBottom: 12 }}>
    {title}
  </Text>
}

/** A page card; numbered cards are the page's sections ("1 · Game setup"). */
export function SetupCard({ number, title, children, padding, accent, testID }: {
  number?: number
  title?: string
  children: React.ReactNode
  padding: number
  /** Border colour override (the special-rules card is amber). */
  accent?: string
  testID?: string
}) {
  return <View testID={testID} className="bg-paper border-2 border-olive rounded-xl"
    style={{ padding, ...(accent ? { borderColor: accent } : null) }}>
    {title && <View className="flex-row items-center" style={{ gap: 10, marginBottom: 4 }}>
      {number !== undefined && <View className="bg-blood rounded-full items-center justify-center" style={{ width: 24, height: 24 }}>
        <Text className="font-stencil text-paper text-xs">{number}</Text>
      </View>}
      <Text accessibilityRole="header" className="font-stencil text-ink uppercase" style={{ fontSize: 17 }}>{title}</Text>
    </View>}
    {children}
  </View>
}
